<template>
<div>
    <div class="container-fluid col-md-11" style="background:rgb(248,249,250); border-radius: 10px; box-shadow: 5px 5px 5px 5px #999999;" id="contenedor">
    <div class="row">
        <div class="col"><br>
            <h2><b>Asignar Imagen</b></h2>
        </div>
    </div>
    
            <div class="row">
                <div class="col-sm-4"><br><br>
                    <label>Seleccionar vendedor</label>
                    <select class="form-select" aria-label="Default select example" id="vendedores"></select><br><br>
                </div>
                <div class="col-sm-2"><br><br>
                    <label>Buscar</label><br>
                     <button class="btn btn-primary btn-block" @click="buscarCheque()">buscar</button>
                </div>

                <div class="col-sm"><br><br><br>
                      <label>Seleccionar archivo</label>
                        <input style="border-color:rgb(237,126,37)" id="archivo" @change="clickImagen($event)" type="file" accept="file/*" ><br>
                </div>
            </div></div>
<br><br><!--
        <div class="container-fluid col-md-11" style="background:rgb(248,249,250); border-radius: 10px; box-shadow: 5px 5px 5px 5px #999999;" id="contenedor">
            <div class="row" >
                    <div class="col-sm-6">
                       <br> <h4>Seleccionar archivo</h4>
                        <input style="border-color:rgb(237,126,37)" @change="clickImagen($event)" type="file" accept="file/*" >
                    </div>

                </div><br>
        </div><br><br>-->
        <div class="container-fluid col-md-11" style="background:rgb(248,249,250); border-radius: 10px; box-shadow: 5px 5px 5px 5px #999999;" id="contenedor">
                <br><h4><b>Pendientes</b></h4>
            <table class="table table-striped">
                <thead style="background-color:rgb(0,58,140);color:white">
                    <tr>
                        <th>N° </th>
                        <th>RUT</th>
                        <th>Nombre titular</th>
                         <th>Razón social</th>
                         <th>RUT facturación</th>
                        <th>Monto</th>
                        <th>Fecha</th>
                        <th>Observacion</th>

                        <th>Asignar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="cheque in Cheques" :key="cheque.key">
                        <td>{{ cheque.documento}}</td>
                        <td>{{ cheque.rut }}</td>
                        <td>{{ cheque.nombreTitular}}</td>
                        <td>{{ cheque.razonSocial}}</td>
                        <td>{{ cheque.rutFacturacion}}</td>
                        <td>{{ cheque.monto }}</td>
                        <td>{{ cheque.fecha}} {{ cheque.hora}}</td>
                        <td>{{ cheque.observacion}}</td>
                        
                        
                        <td>
                            <button type="button" @click="agregarArreglo(cheque.key)" class="btn btn-success btn-sm" style="background-color:rgb(0,56,143) ; color:white;border-color:rgb(237,126,37)"> asignar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <br>
         <br><h4><b>Asignados</b></h4>
            <table class="table table-striped">
                 <thead style="background-color:rgb(0,58,140);color:white">
                    <tr>
                        <th>N° </th>
                        <th>RUT</th>
                        <th>Nombre titular</th>
                         <th>Razón social</th>
                         <th>RUT facturación</th>
                        <th>Monto</th>
                        <th>Observacion</th>
                        <th>Quitar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="cheque in arregloAsignados" :key="cheque.key">
                        <td>{{ cheque.documento}}</td>
                        <td>{{ cheque.rut }}</td>
                        <td>{{ cheque.nombreTitular}}</td>
                        <td>{{ cheque.razonSocial}}</td>
                        <td>{{ cheque.rutFacturacion}}</td>
                        <td>{{ cheque.monto }}</td>
                        <td>{{ cheque.observacion}}</td>
                        <td>
                            <button type="button" @click="quitarArreglo(cheque.key)" class="btn btn-success btn-sm" style="background-color:rgb(0,56,143) ; color:white;border-color:rgb(237,126,37)"> quitar</button>
                        </td>
                        
                    </tr>
                </tbody>
            </table>
            <div class="form-group"><br>
                    <button class="btn btn-primary btn-block" @click="guardarAsignacion()">Guardar</button><br><br>
                </div>
        </div>
            <!--<img class="img-responsive" id="foto"  width="600" ><br>
            <iframe id="pdf" width="100%" height="800px"></iframe>-->
            
      
</div>
</template>

<script>

    import { db } from '../firebaseDb';
    import {storage} from '../firebaseDb';
    import swal from 'sweetalert';
import Swal from 'sweetalert2';
    
    const ref=storage.ref()
    
    export default {
        data() {
            return {
                Cheques: [],
                copia:[],
                arregloAsignados:[],
                imagen:null,
                vendedores:[],
            }
            
        },
        created() {
            this.cargarVendedores();
        },
        methods: {
            verImagen(imagen){
                document.getElementById('foto').src="";
                console.log(imagen)
                const refImg=ref.child('imagenes/'+imagen).getDownloadURL().then(function(url) {
                console.log(refImg)
               
                var img = document.getElementById('foto');
                img.src = url;
                }).catch(function(error) {
                    console.log(error)
                    swal({
                    title: "Error",
                    text: "No hay imagen asociada",
                    icon: "error",
                    })
                });
            },
            verCheque(imagen){
                document.getElementById('pdf').src="";
                console.log(imagen)
                const refImg=ref.child('archivos/test.pdf').getDownloadURL().then(function(url) {
                console.log(refImg)
                var img = document.getElementById('pdf');
                img.src = url;
                }).catch(function(error) {
                    console.log(error)
                    swal({
                    title: "Error",
                    text: "No hay imagen asociada",
                    icon: "error",
                    })
                });
            },
            agregarArreglo(cheque){
                if(this.imagen!=null){
                var data=this.Cheques;
                this.Cheques=[];
                data.forEach((doc) => {
                         if(doc.key!=cheque){
                            this.Cheques.push(doc)
                        }else{
                            //this.arregloAsignados.push(doc)
                            var chequeAsignado = new Object();
								chequeAsignado.key=doc.key;
                                chequeAsignado.documento=doc.documento;
                                chequeAsignado.nombreTitular=doc.nombreTitular;
                                chequeAsignado.rut=doc.rut;
                                chequeAsignado.rutFacturacion=doc.rutFacturacion;
                                chequeAsignado.razonSocial=doc.razonSocial;
                                chequeAsignado.observacion=doc.observacion;
                                chequeAsignado.monto=doc.monto;
                                chequeAsignado.imagen=this.imagen.name;
								chequeAsignado.estado='asignado';
								this.arregloAsignados.push(chequeAsignado)
                        }
                });
                }else{
                    Swal.fire({
                    title: "Aviso",
                    text: "Debe selecionar un archivo",
                    icon: "warning",
                    })
                }
            },
            quitarArreglo(cheque){
                var data=this.arregloAsignados;
                this.arregloAsignados=[];
                data.forEach((doc) => {
                         if(doc.key!=cheque){
                            this.arregloAsignados.push(doc)
                        }else{
                            this.Cheques.push(doc)
                        }
                });
            },
            agregarCopia(dato){
                console.log(dato)
            },
            guardarAsignacion(){
                var data=this.arregloAsignados;
                data.forEach((doc) => {
                    db.collection('cheques').doc(doc.key)
                    .update(doc).then(() => {
                        console.log("Cheque actualizado");
                        Swal.fire({
                        title: "Listo",
                        text: "Cheques con imagen asignada",
                        icon: "success",
                        })
                        this.arregloAsignados=[];
                        this.Cheques=[];
                        document.getElementById("archivo").value="";
                        this.imagen=null;

                    }).catch((error) => {
                        console.log(error);
                    });
                });
                this.subirImagen();
            },
             clickImagen(e){
               this.imagen=e.target.files[0];  
               console.log(this.imagen)
            },
            subirImagen(){
                //referencia de subida
                const refImg=ref.child('archivos/'+this.imagen.name)
                const metadata={contentType:'application/pdf'}
                refImg.put(this.imagen,metadata)
                .then(e=>console.log(e))

            },
            cargarVendedores(){
              //  var vendedor = document.getElementById("vendedores")
                db.collection('usuarios').where("tipo", "==", 1).onSnapshot((snapshotChange) => {
                this.vendedores = [];
                snapshotChange.forEach((doc) => {
                    var option = document.createElement("option")
                    option.value = doc.data().rut,
                    option.innerHTML = doc.data().nombre,
                    document.getElementById("vendedores").appendChild(option)
                    /*this.vendedores.push({
                        key: doc.id,
                        nombre: doc.data().nombre,
                        rut: doc.data().rut,
                        
                    })*/
                });
            })
            },
            buscarCheque(){
                console.log("aca")
                var usuario=document.getElementById("vendedores").value;
                db.collection('cheques').where("estado", "==", 'pendiente').where("usuario", "==", usuario).onSnapshot((snapshotChange) => {
                this.Cheques = [];
                if(snapshotChange.empty){
                    Swal.fire({
                    title: "Aviso",
                    text: "No se encontraron cheques pendientes",
                    icon: "info",
                    })
                }else{
                     snapshotChange.forEach((doc) => {
                    
                    this.Cheques.push({
                       key: doc.id,
                        documento: doc.data().documento,
                        rut: doc.data().rut,
                        nombreTitular: doc.data().nombreTitular,
                        rutFacturacion: doc.data().rutFacturacion,
                        razonSocial: doc.data().razonSocial,
                        observacion: doc.data().observacion, 
                        monto: doc.data().monto,
                        imagen: doc.data().imagen
                    })
                });
                }
               
            })
            }
        }
    }
</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
</style>